import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/ManageSortflag.css';
import SalespersonSidebar from "./SalespersonSidebar";
// import { useMockServer } from '@mui/x-data-grid-generator';

 
const columns = [
  
  { field: 'name', headerName: 'Name',cellClassName:'name_column',headerClassName:'name_header'},
  { field: 'bound', headerName: '# Bound	',cellClassName:'bound_column',headerClassName:'bound_header',sortable: false,renderCell: (params) => (
      <Link href={params.row.bound_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.bound}
      </Link>
    )},
  {
    field: 'edit_link',
    headerName: 'Actions',cellClassName:'actions_column',headerClassName:'actions_header',
    renderCell: (params) => (
      <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer"  style={{ color: "#2C99D2"}}>
        Edit
      </Link>
    ),
    sortable: false
  }
  
  
];

const ManageSortflag =() =>{
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 100 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const[salespersonList, setSalespersonList] = useState({});
  const [statelist, setStateList] = useState({});
  const [isLoading, setIsLoading] = useState(true);
const app_url = configData.APP_URL;
const [formData, setformData] = useState({
       name:''
    });
const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
  };
  React.useEffect(() => {
     
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
      try {
         setIsLoading(true);
      const response = await fetch(app_url+'sortflag/sortflaglist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:formData
          
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };

    fetchData();
  }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change


  
 
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
         setIsLoading(true);
      const response = await fetch(app_url+'sortflag/sortflaglist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
  }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }

  
}; 

    return(
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
            <Helmet><title>Sort Flags</title></Helmet>
            <div class="left"></div>
               
               <div class="center left-center">
                    <div className="sortflags-container">
                       <h1>Sort Flags</h1>
                          <p><a href="/admin/structure/taxonomy/sort_flags/add">Add Terms</a></p>
                           <div className="sortflags-view-filters">
                                <form id="views-exposed-form-sa-admin-user-list-page">
                                    <div className="sortflags-views-exposed-form">
                                    <div className="sortflags-views-exposed-widgets">
                                        
                                        
                                         
                                        {/* First Name */}
                                        <div
                                        id="edit-neme-wrapper"
                                        className="sortflags-views-exposed-widget sortflags-views-widget-filter-name_value"
                                        >
                                        <label htmlFor="edit-name-value">Name</label>
                                        <div className="sortflags-views-widget">
                                            <div className="sortflags-form-item">
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                size="30"
                                                maxLength="128"
                                                className="sortflags-form-text" onChange={handleChange} 
                                                value={formData.name}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                       
                                        {/* Submit Button */}
                                        <div className="sortflags-views-exposed-widget sortflags-views-submit-button">
                                        
                                        <button className='form-submit sortflags-formsubmit' type="submit" onClick={handleSubmit}>Apply</button>
                                       
                                        </div>

                                    </div>
                                    </div>
                                  
                                </form>
                              </div>
                     
                        <div className="sortflags-view-content">
                            <table className="sortflags-views-table">
                                   <div style={{ width: '100%' }}>
                                    <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    rowCount={rowCount}
                                    paginationMode="server"
                                    sortingMode="server"
                                    filterMode="server"
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                     filterModel={filterModel}
                                    onFilterModelChange={setFilterModel}
                                    pageSizeOptions={[5, 10, 25,50]}
                                    getRowId={() => crypto.randomUUID()}
                                    getRowHeight={() => 'auto'}
                                    disableColumnFilter 
                                    disableColumnResize={true}
                                />
    </div>
                            </table>
                        </div>

                    </div>

                
        </div>
       <div class="right">
            <SalespersonSidebar/>
        </div>
        </div>
        
     )}
    </>
  )
};

export default ManageSortflag;